import { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { COMPANY } from '@/lib/data';
import { trackEvent } from '@/lib/analytics';
import { cn } from '@/lib/utils';

export const FloatingWhatsApp = () => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => setMounted(true), 600);
        return () => clearTimeout(t);
    }, []);

    const onClick = () => trackEvent('whatsapp_click', window.location.pathname, { from: 'floating' });

    return (
        <a
            href={COMPANY.whatsapp}
            target="_blank"
            rel="noreferrer"
            data-testid="floating-whatsapp-button"
            aria-label="Contáctanos por WhatsApp"
            onClick={onClick}
            className={cn(
                'group fixed z-50 bottom-6 right-6 sm:bottom-8 sm:right-8 flex items-center gap-3',
                'transition-all duration-500',
                mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
            )}
        >
            <span className="hidden sm:inline-flex items-center px-3 py-2 rounded-lg bg-foreground text-background text-xs font-medium shadow-lg whitespace-nowrap opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
                Chatea con un asesor
                <span className="absolute -right-1 top-1/2 -translate-y-1/2 size-2 rotate-45 bg-foreground" />
            </span>

            <span className="relative inline-flex">
                <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-ping" />
                <span className="relative inline-flex items-center justify-center size-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.7)] ring-2 ring-white/40 transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6">
                    <svg viewBox="0 0 32 32" aria-hidden="true" className="size-7 drop-shadow" fill="currentColor">
                        <path d="M16.001 3.2C8.927 3.2 3.2 8.927 3.2 16.001c0 2.258.595 4.464 1.728 6.404L3.2 28.8l6.555-1.708a12.74 12.74 0 0 0 6.246 1.62h.006c7.072 0 12.8-5.726 12.8-12.8 0-3.42-1.332-6.636-3.752-9.054A12.711 12.711 0 0 0 16.001 3.2zm0 23.466h-.005a10.62 10.62 0 0 1-5.41-1.48l-.388-.23-3.892 1.014 1.038-3.79-.252-.4a10.616 10.616 0 0 1-1.62-5.78c0-5.86 4.77-10.63 10.633-10.63 2.838 0 5.506 1.107 7.513 3.116a10.56 10.56 0 0 1 3.116 7.518c0 5.864-4.77 10.662-10.633 10.662zm5.83-7.974c-.32-.16-1.892-.934-2.185-1.04-.293-.107-.506-.16-.72.16-.213.32-.825 1.04-1.012 1.253-.186.213-.373.24-.693.08-.32-.16-1.35-.498-2.572-1.587-.95-.846-1.59-1.893-1.776-2.213-.186-.32-.02-.493.14-.653.144-.142.32-.373.48-.56.16-.187.213-.32.32-.534.107-.213.053-.4-.026-.56-.08-.16-.72-1.733-.986-2.374-.26-.624-.526-.54-.72-.55l-.613-.011a1.18 1.18 0 0 0-.853.4c-.293.32-1.12 1.094-1.12 2.667 0 1.574 1.146 3.094 1.306 3.307.16.213 2.253 3.44 5.46 4.826.762.33 1.357.527 1.82.674.764.243 1.46.21 2.01.127.612-.091 1.892-.773 2.16-1.52.266-.747.266-1.387.186-1.52-.08-.133-.293-.213-.613-.373z" />
                    </svg>
                </span>
            </span>
        </a>
    );
};

export default FloatingWhatsApp;
